module.exports = "pegasus/assets/theme2/medium/7.jpg";